import { render, staticRenderFns } from "./CierreCabecera.vue?vue&type=template&id=8b597a90&scoped=true"
import script from "./CierreCabecera.vue?vue&type=script&lang=js"
export * from "./CierreCabecera.vue?vue&type=script&lang=js"
import style0 from "./CierreCabecera.vue?vue&type=style&index=0&id=8b597a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b597a90",
  null
  
)

export default component.exports